import { useToast } from 'contexts/ToastContext';

const ToastContainer = () => {
  const { toasts, removeToast } = useToast();

  return (
    <div className="fixed right-4 top-4 z-50 space-y-3">
      {/* Global toast surface keeps success messages consistent across routes. */}
      {toasts.map((toast) => {
        const variantStyles =
          toast.variant === 'success'
            ? 'border-green-200 bg-green-50 text-green-900'
            : toast.variant === 'error'
              ? 'border-red-200 bg-red-50 text-red-900'
              : 'border-gray-200 bg-white text-gray-900';

        return (
          <div
            key={toast.id}
            className={`flex items-start justify-between gap-4 rounded-md border px-4 py-3 text-sm shadow ${variantStyles}`}
          >
            <span className="flex-1">{toast.message}</span>
            <div className="flex items-center gap-2">
              {toast.actionLabel && toast.onAction && (
                <button
                  type="button"
                  onClick={() => {
                    toast.onAction?.();
                    removeToast(toast.id);
                  }}
                  className="text-xs font-medium text-proposio-purple hover:underline"
                >
                  {toast.actionLabel}
                </button>
              )}
              <button
                type="button"
                onClick={() => removeToast(toast.id)}
                className="text-xs text-gray-500 hover:text-gray-700"
                aria-label="Dismiss notification"
              >
                Close
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ToastContainer;
